module.exports = __webpack_public_path__ + "static/media/experimentation-large.197f9e90.png";